// 标记提醒
import taoke_module_new_list from '@/api/taoke_module_new_list'
import taoke_module_new_mark from '@/api/taoke_module_new_mark'

const badge = {
  state: {
    status: {
      // 授权剩余不足7天: true
      authRemain7day: false,
      // 提现申请新消息：true
      applyCashMsg: false,
      //  代理申请新消息：true
      applyagentMsg: false,
    },
    
    // 淘客自己没用过的新权限
    moduleNews: [],
  },
  mutations: {

    UPDATE_AUTHREMAIN7DAY(state, data) {
      const exp = data.taobao_expires_at
      const now = Date.now()
      let day = 0
      let diff = exp - now
      if (now > exp) {
        day = 0
      }
      day = Math.floor(diff / 1000 / 60 / 60 / 24)

      //拼多多
      // const pdd_exp = data.pdd_expires_at
      // let pdd_day = 0
      // let pdd_diff = pdd_exp - now
      // if (now > pdd_exp) {
      //   pdd_day = 0
      // }
      // pdd_day = Math.floor(pdd_diff / 1000 / 60 / 60 / 24)
      state.status.authRemain7day = day <= 7
      // state.status.authRemain7day = day <= 7 || pdd_day <= 7||data.pdd_expires_at==undefined
    },
    UPDATA_CASHMSG(state, count) {
      state.status.applyCashMsg = count
    },
    UPDATA_AGENTMSG(state, count) {
      state.status.applyagentMsg = count
    },
    UPDATE_MODULE_NEWS(state, data) {
      state.moduleNews = data
    },
  },
  actions: {
    // 淘客获取自己没用过的新权限
    async GetModuleNewList({commit}) {
      const {data} = await taoke_module_new_list()
      if(data.error_code !== 0) {
        return this.$message.error(data.error_message)
      }
      commit('UPDATE_MODULE_NEWS', data.module)
    },
    // 标记淘客没用过的新权限
    async SetModuleNewMark({state, dispatch}, {route}) {
      var markModule = state.moduleNews.find((i) => i.module === route.path)
      if(!markModule) return
      const {data} = await taoke_module_new_mark({module: markModule.module})
      if(data.error_code !== 0) {
        return this.$message.error(data.error_message)
      }
      dispatch('GetModuleNewList')
    },
  },
}

export default badge
